//colorSlice.js
import { createSlice } from '@reduxjs/toolkit';  
  
export const colorSlice = createSlice({  
  name: 'color',  
  initialState: {
    value: '#0e08f9', 
  },  
  reducers: {  
    setColor: (state, action) => {  
      state.value = action.payload;  
    },  
  },  
});  
  
export const { setColor } = colorSlice.actions;  
  
export default colorSlice.reducer;